import React from "react";
import classNames from "classnames";
import { Icon } from "./Icon";
export const SubmitButton = (props) => {
    const { loadState, percentage } = props;
    const submitBtnCSS = classNames("submit-button", { "submitting": loadState == 'submitting', "saved": loadState == 'saved' });
    var r = 12;
    var c = Math.PI * (r * 2);
    var val = props.percentage;
    if (val < 0) {
        val = 0;
    }
    if (val > 100) {
        val = 100;
    }
    var pct = ((100 - val) / 100) * c;
    return (React.createElement("button", { className: submitBtnCSS, onClick: props.onClick },
        React.createElement("span", { className: "text" }, props.label),
        percentage ?
            React.createElement("div", { className: "percentage-stat" },
                React.createElement("svg", { className: 'svg-circle', width: r * 2 + 6, height: r * 2 + 6 },
                    React.createElement("circle", { r: r, cx: r + 3, cy: r + 3, fill: 'transparent', strokeDasharray: '182.21' }),
                    React.createElement("circle", { className: 'bar', strokeDashoffset: pct, r: r, cx: r + 3, cy: r + 3, fill: 'transparent', strokeDasharray: c })),
                React.createElement("div", { className: "pctfig" }, val))
            :
                React.createElement("div", { className: "ispinner ispinner-inverse" },
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" }),
                    React.createElement("div", { className: "ispinner-blade" })),
        React.createElement(Icon, { c: ['tick-circle', 24, 24, 'tick-icon'] })));
};
